import { NavigationSubItem } from "../navigation-item"

export class ClassicLiquiditySubItem extends NavigationSubItem {
  readonly id = "classic"
  readonly label = "Classic"
  readonly href = "/liquidity"
  readonly iconName = "overview-icon"
  readonly isExternal = false
  readonly tabs = []
}
